<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="48" cy="37" r="12" stroke="black" stroke-width="4"/>
<path d="M30 74.5V59C30 57.3431 31.3431 56 33 56H63C64.6569 56 66 57.3431 66 59V75" stroke="black" stroke-width="4"/>
<path d="M44 81L45.1954 56H50.8046L52 81" stroke="black" stroke-width="4"/>
<path d="M45 63H51" stroke="black" stroke-width="4"/>
<circle cx="47.669" cy="47.1066" r="33" transform="rotate(-45 47.669 47.1066)" stroke="black" stroke-width="4"/>
<path d="M71.3943 71L72.0341 71.6399M72.4031 72.0089L72.0341 71.6399M76.0928 75.6986L72.0341 71.6399" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path class="bar" d="M85.8344 85.4407L81.0821 80.6885M80.6822 80.2885L81.0821 80.6885M76.6828 76.2891L81.0821 80.6885" stroke="black" stroke-width="7" stroke-linecap="square"/>
</svg>

</template>
